import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ParcelsService} from '../../services/parcels.service';
import {UrlService} from '../../services/url.service';
import {AuthenticationService} from '../../services/authentication.service';
import {merge} from 'rxjs/observable/merge';
import {Subject} from 'rxjs/Subject';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'parcels.component.html',
})
export class ParcelsComponent implements OnInit, OnDestroy {
    $destroy = new Subject();

    constructor(public parcelsService: ParcelsService,
                private authenticationService: AuthenticationService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        if (!this.authenticationService.userIsResident) {
            merge(
                this.parcelsService.getPostServices(),
                this.parcelsService.getParcelTypes()
            )
                .pipe(
                    takeUntil(this.$destroy)
                )
                .subscribe();
        }
        this.parcelsService.getBuildings();
        this.urlService.onUrlChange
            .pipe(
                tap(() => this.parcelsService.tabId = this.urlService.queryParams['tab']),
                flatMap(
                    () => {
                        return this.parcelsService.getDataByQueryParams(true)
                            .pipe(
                                takeUntil(this.urlService.instantOnUrlChange)
                            );
                    }
                ),
                takeUntil(this.$destroy)
            )
            .subscribe();
        this.urlService.queryParams['status'] = 'received';
        this.urlService.setQueryParams('allParcels');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.parcelsService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.parcelsService.emptyRowService.fillEmptyRow();
    }

}





// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcels.component.ts